import React, { useState } from "react";
import {
  ModalComp,
  Scenario,
  Automation,
  DeviceOrg,
  Add,
  Profile,
} from "../../../shared";
import Carousel from "react-elastic-carousel";
import { AddItemsCard } from "../";
import "./style.css";
import { ScenariosOpt } from "./ScenariosOpt";
import { useTranslation } from "react-i18next";
import { FiX, FiPlus, FiCpu, FiZap, FiHome, FiClock, FiUsers, FiGrid } from "react-icons/fi";

const Options = ({ toggleOptions, toggle }) => {
  const { t } = useTranslation();
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [openAddAutomationModal, setOpenAddAutomationModal] = useState(false);
  const [openDeviceOrgModal, setOpenDeviceOrgModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  const toggleScenario = () => setOpenScenarioModal(!openScenarioModal);
  const toggleAddAutomation = () =>
    setOpenAddAutomationModal(!openAddAutomationModal);
  const toggleDeviceOrg = () => setOpenDeviceOrgModal(!openDeviceOrgModal);
  const toggleAdd = () => setOpenAddModal(!openAddModal);

  const menuItems = [
    { icon: <FiCpu size={20} />, label: t("دستگاه"), action: toggleDeviceOrg, color: "#667eea" },
    { icon: <FiZap size={20} />, label: t("سناریو"), action: toggleScenario, color: "#ff9800" },
    { icon: <FiHome size={20} />, label: t("اتاق"), action: toggleAdd, color: "#00c853" },
    { icon: <FiClock size={20} />, label: t("اتوماسیون"), action: toggleAddAutomation, color: "#9c27b0" },
    { icon: <FiUsers size={20} />, label: t("اعضا"), action: null, color: "#2196f3" },
    { icon: <FiGrid size={20} />, label: t("ساختمان"), action: toggle, color: "#f56565" },
  ];

  return (
    <>
      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenario}
        component={<Scenario />}
        dark={true}
      />
      <ModalComp
        modal={openAddAutomationModal}
        toggle={toggleAddAutomation}
        component={<Automation />}
        dark={true}
      />
      <ModalComp
        modal={openDeviceOrgModal}
        toggle={toggleDeviceOrg}
        component={<DeviceOrg />}
        dark={true}
      />
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />

      <div className="options-modal-overlay">
        <div className="options-modal-container">
          {/* Header */}
          <div className="options-modal-header">
            <div className="options-modal-title">
              <FiPlus size={20} />
              <span>{t("اضافه کردن")}</span>
            </div>
            <button className="options-modal-close" onClick={toggleOptions}>
              <FiX size={18} />
            </button>
          </div>

          {/* Menu Items Grid */}
          <div className="options-modal-grid">
            {menuItems.map((item, index) => (
              <div
                key={index}
                className="options-modal-item"
                onClick={item.action}
                style={{ cursor: item.action ? "pointer" : "not-allowed", opacity: item.action ? 1 : 0.5 }}
              >
                <div className="options-modal-icon" style={{ background: `${item.color}15`, color: item.color }}>
                  {item.icon}
                </div>
                <span className="options-modal-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export { Options };